import { GetAccrualsConfig } from '../../../domain/usecases/';
import { BaseHttpService } from 'main/factories/http';

export class RemoteGetAccrualsConfig extends BaseHttpService<GetAccrualsConfig.Model> implements GetAccrualsConfig {
  async getAccrualsConfig(): Promise<any> {
    return await this.request('get');
  }
}
